import { useIsFetching } from '@tanstack/react-query';
import usePage from '@dashboard/hooks/usePage';
import { guestQuestionsKey } from '@dashboard/lib/queryKeys';

// Guest questions save outside the page and only refetch afterwards; their first load is not a save.
export default function usePageSaving() {
  const { page, isRefetching, updatePage } = usePage();
  const guestQuestionsRefetching = useIsFetching({
    queryKey: guestQuestionsKey(page?._id),
    predicate: query => query.state.data !== undefined,
  });
  return Boolean(isRefetching || updatePage?.isPending || guestQuestionsRefetching > 0);
}
